import { Component, Input } from '@angular/core';
import { Scadenza } from '../../../models/scadenza';

@Component({
    selector: '[scadenza_entity_view]',
  templateUrl: 'scadenza-entity-view.component.html',
})

export class ScadenzaEntityViewComponent {
  @Input()
  element: Scadenza;
}
